export const Spa2Route = {
    INBOX: (channelId?: string) =>
        channelId
            ? `${process.env.VUE_APP_CLUB_BASE_URL}/inbox?id=${channelId}`
            : `${process.env.VUE_APP_CLUB_BASE_URL}/inbox`,
    INBOX_NEW: (idff?: string) => `/inbox/new/${idff}`,
}
